"use strict";
/*
 * Created on 09 02 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductSupplier_1 = require("./ProductSupplier");
/**
 * <p>
 *     Each of P&P applications uses the same base algorithm to find preferred {@link Supplier supplier} of a {@link Product product}.
 *     The algorithm uses {@link SupplierSiteBinding supplier site bindings} as primary source, which includes {@link TimedRecord validity}
 *     and reference to {@link InternalSite internal site}.
 * </p>
 *
 * <p>
 *     The preferred supplier may not be found based on the algorithm and source stated above. This entity encapsulates additional mapping
 *     of {@link Product product} and {@link Supplier preferred supplier}, but without {@link TimedRecord validity} and reference to
 *     {@link InternalSite internal site}. Data formed by this entity should be used as fallback when preferred supplier has not been
 *     found based on {@link SupplierSiteBinding supplier site bindings}.
 * </p>
 *
 * <p>
 *     <b>
 *         This entity stores data without relevance to time validity (it is not {@link TimedRecord}). If it would be needed, we can
 *         maintain history based on source data changes at our side (but implemented as paid work).
 *     </b>
 * </p>
 *
 * @author JMe
 */


var ProductPreferredSupplier =
/*#__PURE__*/
function (_ProductSupplier_1$Pr) {
  _inherits(ProductPreferredSupplier, _ProductSupplier_1$Pr);

  /**
   * @param id internal document id
   * @param productId {@link Product.id}
   * @param supplierId {@link Supplier.id}
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function ProductPreferredSupplier(id, productId, supplierId, processed) {
    var _this;

    _classCallCheck(this, ProductPreferredSupplier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductPreferredSupplier).call(this, productId, supplierId));
    _this.id = id;
    _this.productId = productId;
    _this.supplierId = supplierId;
    _this.processed = processed;
    return _this;
  }

  return ProductPreferredSupplier;
}(ProductSupplier_1.ProductSupplier);

exports.ProductPreferredSupplier = ProductPreferredSupplier;